import PropTypes from 'prop-types';
import { AppContextProvider } from './App.context';
import { SessionTimeoutWarning } from './SessionTimeoutWarning.component';
import { PasswordExpiration } from './PasswordExpiration.component';
import { GlobalEventSettingsProvider } from './globalEventSettings.context';
import { SnackbarProvider } from './SnackbarProvider.component';
import { SmartTextSettingsProvider } from './smartTextSettings.context';

export const AppSharedContextProvider = ({ children }) => (
  <AppContextProvider>
    <SessionTimeoutWarning />
    <PasswordExpiration />
    <SnackbarProvider>
      <SmartTextSettingsProvider>
        <GlobalEventSettingsProvider>
          {children}
        </GlobalEventSettingsProvider>
      </SmartTextSettingsProvider>
    </SnackbarProvider>
  </AppContextProvider>
);

AppSharedContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
